module.exports = __webpack_public_path__ + "img/WMS2.cfa33643.png";